import { useRef as E, useEffect as m } from "react";
import { useIsoMorphicEffect as T } from './use-iso-morphic-effect.js';
import { getOwnerDocument as N } from '../utils/owner.js';
function F(_ref) {
  var e = _ref.container,
    t = _ref.accept,
    r = _ref.walk,
    _ref$enabled = _ref.enabled,
    c = _ref$enabled === void 0 ? !0 : _ref$enabled;
  var o = E(t),
    l = E(r);
  m(function () {
    o.current = t, l.current = r;
  }, [t, r]), T(function () {
    if (!e || !c) return;
    var n = N(e);
    if (!n) return;
    var f = o.current,
      p = l.current,
      d = Object.assign(function (i) {
        return f(i);
      }, {
        acceptNode: f
      }),
      u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
    for (; u.nextNode();) p(u.currentNode);
  }, [e, c, o, l]);
}
export { F as useTreeWalker };